<template>
  <ul class="page">
    <li v-if="currentPage !== 1"
        class="page-item"
        @click="handleSetPage(currentPage - 1)">
      上一页
    </li>
    <li v-else class="page-item page-item-disable">
      上一页
    </li>
    <template v-for="(item, index) in pageArray">
      <li v-if="item === 0"
          :key="index"
          class="page-rest">...</li>
      <li v-else
          :key="index"
          :class="{'page-size-active' : item === currentPage}"
          class="page-size"
          @click="handleSetPage(item)">
        {{ item }}
      </li>
    </template>
    <li class="page-item" @click="handleSetPage(pageCount)">
      尾页
    </li>
    <li v-if="pageCount !== currentPage" class="page-item"
        @click="handleSetPage(currentPage + 1)">
      下一页
    </li>
    <li v-else class="page-item page-item-disable">
      下一页
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Page',
  computed: {
    pageCount () {
      return this.pageSize ? Math.ceil(this.total / this.pageSize) : 1
    },
    // eslint-disable-next-line sonarjs/cognitive-complexity
    pageArray () {
      const array = []
      // 如果小于6页
      if (this.pageCount <= 6) {
        for (let index = 0; index < this.pageCount; index++) {
          array.push(index + 1)
        }
      } else if (this.currentPage <= 3) {
        array.push(1)
        array.push(2)
        array.push(3)
        array.push(4)
        array.push(0)
        array.push(this.pageCount - 1)
        array.push(this.pageCount)
      } else if (this.pageCount - this.currentPage <= 3) {
        array.push(1)
        array.push(2)
        array.push(0)
        array.push(this.pageCount - 4)
        array.push(this.pageCount - 3)
        array.push(this.pageCount - 2)
        array.push(this.pageCount - 1)
        array.push(this.pageCount)
      } else {
        array.push(0)
        array.push(this.currentPage - 2)
        array.push(this.currentPage - 1)
        array.push(this.currentPage)
        array.push(this.currentPage + 1)
        array.push(0)
        array.push(this.pageCount - 1)
        array.push(this.pageCount)
      }
      return array
    }
  },
  props: {
    total: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
  },
  methods: {
    handleSetPage (currentPage) {
      this.$emit('page-change', currentPage)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/style/styleMixins";
.page{
  .flex_align_center_mixins;
  &-size{
    height: 36px;
    width: 36px;
    background: #F8F8F8;
    border: 1px solid #999999;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    margin-right: 10px;
    cursor: pointer;
    .flex_center_mixins;
    &-active{
      background: #3D6BFF;
      border-radius: 6px;
      color: white;
    }
  }
  &-item{
    margin-right: 10px;
    height: 36px;
    background: #F8F8F8;
    border: 1px solid #999999;
    border-radius: 6px;
    padding: 0 10px;
    cursor: pointer;
    .flex_center_mixins;
    &-disable{
      cursor: not-allowed;
    }
  }
  &-rest{
    margin-right: 10px;
  }
}
</style>
